import React from 'react';
import { originalStatus } from 'features/costing/utils';

import { changeDateFormat, getActionDoneBy, getCostingActivityStatus } from '@utils/Util';

const CostingTimeline = ({ requiredDate, activityList }) => {
	return (
		<div className="design-timeline-container">
			<div className="design-timeline-header mb-4">
				<p className="semibold-16 mb-0">Costing Timeline</p>
				<p className="regular-14 gray_dark_02">
					Required: {changeDateFormat(requiredDate, '', 'Do MMM')}
				</p>
			</div>
			<ul className="design-timeline design-timeline-centered">
				{activityList?.map((item) => (
					<li
						className={`design-timeline-item status ${
							item?.completeStatus === 'COMPLETED' || item?.status === 'ARCHIVE'
								? getCostingActivityStatus(item?.status, 'TIMELINE_STATUS')
								: ''
						}`}
						key={item?.status}
					>
						<div className="design-timeline-marker" />
						<div className="design-timeline-content">
							<p className="regular-14">
								{(['APPROVED', 'REJECTED'].includes(item?.status) ? 'Costing ' : '') +
									originalStatus[item?.status] +
									getActionDoneBy(item?.userType || null)}
							</p>
							<span className="regular-12 gray_dark_03">
								{changeDateFormat(item?.dateTime, '', 'Do MMM')}
							</span>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default CostingTimeline;
